/**
 * PAR date utility helpers.
 */

/**
 * Computes the difference in whole days between two date strings (YYYY-MM-DD).
 * Returns a + integer when `a` is later than `b`, negative when earlier.
 * The T00:00:00 suffix forces parsing in local midnight time to avoid
 * timezone-dependent rounding.
 */
export function daysBetween(a: string, b: string): number {
  return Math.round(
    (new Date(a + "T00:00:00").getTime() - new Date(b + "T00:00:00").getTime()) / 86400000
  );
}
